import { Translations } from './en';

const fr: Translations = {
  addSegment: 'Ajouter un segment',
  addSegmentSubtitle: 'Créez un segment de contributeurs',
  createContributorSegment: 'Créez un segment de contributeurs',
  icon: 'Icône',
  name: 'Nom',
  exampleEnglishLevel1: 'Exemple : Anglais Niveau 1',
  socio: 'Socio',
  manual: 'Manuelle',
  competence: 'Compétence',
  defineSelectionCriteria: 'Vous définissez des critères de sélection socio-démographiques',
  manualContributorSelection:
    'Vous sélectionnez manuellement les contributeurs qui ont une certaines compétences',
  specificCompetenceSelection:
    'Vous sélectionnez les contributeur selon une compétence spécifique.',
  back: 'Retour',
  next: 'Suivant',
  outOf: 'sur',
  users: 'Utilisateurs',
  import: 'Importer',
  addUsers: 'Ajouter des utilisateurs',
  search: 'Rechercher',
  add: 'Ajouter',
  creator: 'Créateur',
  audience: 'Audience',
  listSizeVaries:
    'La taille de la liste peut varier dans le temps en fonction de vos paramètres et des données disponibles',
  validate: 'Valider',
  addAll: 'Ajouter tous',
  chooseManagers: 'Choisir des managers',
  ownerAndAdministrators: 'Proprietaire & Administrateurs',
  usagePermissions: 'Permissions d’utilisation',
  openToAll: 'Ouvert à tous',
  finish: 'Terminer',
  groupMarseille: 'Groupe Marseille',

  socioDemographic: 'Socio-démographique',
  parameter: 'Paramètre',
  country: 'Pays',
  criterion: 'Critère',
  usersMustRespect: 'Les utilisateurs doivent respecter au moins un des critères choisis.',
  gender: 'Genre',
  man: 'Homme',
  age: 'Âge',
  seniority: 'Ancienneté',
  skillCriterion: 'Critère de compétence',
  searchSkill: 'Rechercher une compétence',
  usersAreEvaluated: 'Les utilisateurs sont évalués sur l’ensemble des compétences suivantes',
  entry: 'Saisie',
  cutout: 'Détourage',
  minimumNumberOfTreatmentsEvaluated: 'Nombre minimum de traitements évalués',
  minimumQuality: 'Qualité minimum',
  criteria: {
    0: 'Âge',
    1: 'Pays',
    2: 'Département',
    3: 'Région',
    4: 'Nationalité',
    5: 'Genre',
    6: 'Ancienneté',
    7: 'Secteur d’activité',
    8: 'Profession',
    9: 'Nombre d’enfants',
    10: 'Situation familiale',
    11: 'Niveau de revenu',
    12: 'Études',
  },
};

export default fr;
